import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { ConfigContext } from '../../../../contexts/ConfigContext';
import * as actionType from '../../../../store/actions';
import logo from "../../../../assets/images/logo.png"

const NavLogo = () => {
  const configContext = useContext(ConfigContext);
  const { collapseMenu } = configContext.state;
  const { dispatch } = configContext;

  let toggleClass = ['mobile-menu'];
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on'];
  }

  return (
    <React.Fragment>
      <div className="navbar-brand header-logo">
        <Link to="#" className="b-brand">
        {/* <img className="rounded-circle" style={{ width: '40px' }} src={logo} alt="activity-user" /> */}
          <div className="b-bg">
            <i className="feather icon-trending-up" />
          </div>
          <span className="b-title">Glag</span>
        </Link>
        <Link 
        to="#"   
        style={{color: 'white', }}  
        className={toggleClass.join(' ')} 
        id="mobile-collapse" onClick={() => 
        dispatch({ type: actionType.COLLAPSE_MENU })}
        >
        <span style={{ color: 'inherit' }} />
       
        </Link>
      </div>
    </React.Fragment>
  );
};

export default NavLogo;
